import { Component } from '@angular/core';
import { SOLUTION_PAGE_CONFIGS } from 'src/app/shared/components/solution-page/solution-page.config';

@Component({
  selector: 'app-solution6',
  templateUrl: './solution6.component.html',
  styleUrls: ['./solution6.component.scss'],
})
export class Solution6Component {
  readonly pageConfig = SOLUTION_PAGE_CONFIGS[6];
}
